exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-lista[data-v-2d01dd84]{vertical-align:bottom}.panel-top[data-v-2d01dd84]{border-top:1px solid #fff}.panel-top-groups[data-v-2d01dd84]{border-top:1px solid #fff;padding:.3rem}.is-checkradio[type=checkbox]:checked+label[data-v-2d01dd84]:before,.is-checkradio[type=radio]:checked+label[data-v-2d01dd84]:before{border:.15rem solid #dbdbdb}.is-checkradio[type=checkbox]+label[data-v-2d01dd84]:after{border-width:.15rem}.buttons-actions-groups[data-v-2d01dd84]{display:flex;justify-content:space-between;gap:.3rem;margin-bottom:.3rem}.ms-multiline[data-v-2d01dd84]{display:block;white-space:normal;word-break:break-word;line-height:1.3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d01dd84","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/components/graficas/Panel.vue
// module id = 958
// module chunks = 2